import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { isArrayNullOrEmpty, isNullOrEmpty } from "../helper/helper";
import { OrganisationPermission } from "../models/organisation/OrganisationModelV2";
import { ReactComponent as PemBoyCheck } from "../rsc/pemboy_checkin.svg";


type MissingPermissionType = 'write' | 'read'
type MissingPermissionContextType = 'bid' | 'org'

type Props = {
    context: MissingPermissionContextType
    subtitle?: string
    title: string
    orgPermission?: OrganisationPermission
}

export function MissingPermissionView({ context: type, title, subtitle, orgPermission }: Props) {

    const [missingPermissions, setMissingPermission] = useState<MissingPermissionType[]>()

    useEffect(() => {
        const res: MissingPermissionType[] = []
        if (type == 'bid') {
            if (orgPermission?.bid_read === false) {
                res.push('read')
            }
            if (orgPermission?.bid_write === false) {
                res.push('write')
            }
        }
        setMissingPermission(res)
    }, [orgPermission])

    const getStringPermission = () => {
        var res = ''
        missingPermissions?.forEach(p => {
            if (isNullOrEmpty(res)) {
                res += t(p)
            } else {
                res += `, ${t(p)}`
            }
        })
        return res
    }

    const getStringType = () => {
        if (type === 'bid') {
            return t('bid')
        } else {
            return (t('org'))
        }
    }

    return (
        <div className="lightGreyBgColor" style={{width:'100%', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.04)'}} hidden={isArrayNullOrEmpty(missingPermissions)}>
            <div className="pempem-flex-row-center gap10" style={{ width: '100%', padding: '32px 24px', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                <div className="pempem-flex-col">
                    <div className="font-32 bold" style={{ marginBottom: 8, color: '#888' }}>{title}</div>
                    <div className="font-normal" style={{ color: '#aaa' }}>{subtitle ?? t('missing_permission_message', { permission: getStringPermission(), type: getStringType() })} </div>
                </div>
                <PemBoyCheck />
            </div>
        </div>
    )
}